import React, { FC } from 'react'
import CheckboxListFacet from '../components/CheckboxListFacet'
import { BaseFacetProps } from '../types'
import { OVERRIDE_ORIENTATION_MAPPING_RULES } from '../helpers/constants'

const ORIENTATION = ['landscape', 'portrait', 'square']

const StatusFacet: FC<BaseFacetProps> = ({ baseUrl, nextAppRoute }) => {
  return (
    <CheckboxListFacet
      facetName='orientation'
      attributesList={ORIENTATION}
      overrideCheckboxTextRules={OVERRIDE_ORIENTATION_MAPPING_RULES}
      baseUrl={baseUrl}
      nextAppRoute={nextAppRoute}
    />
  )
}

export default StatusFacet
